import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { Modal, ModalBody } from "reactstrap";

import { resetSession } from "@/redux/auth";

import UnAuthorizedFullpageModal from "@/components/commons/ErrorSuccessModal/UnAuthorizedFullpageModal";

import {
  AlertIcon,
  Error,
  ForwardTicketIcon,
  SuccessFill,
  TryAgainLaterIcon,
  Warning,
} from "@/assets/images";

type AppProps = {
  isOpen: boolean;
  toggle?: any;
  message?: string | null;
  onPress: () => void;
  statusCode?: any;
  title: string;
  buttonText: string;
  type: string;
};

const ErrorSuccessModal = ({
  isOpen,
  toggle,
  message,
  statusCode,
  buttonText,
  title,
  onPress,
  type,
}: AppProps) => {
  const dispatch = useDispatch();
  const history = useNavigate();
  const [open, setOpen] = useState(false);

  const dispatchLogoutUser = () => {
    dispatch(resetSession());
  };
  useEffect(() => {
    if (message?.includes("You're Not Authorized")) {
      setOpen(true);
    }
  }, [message, history, onPress]);

  return (
    <>
      {open ? (
        <UnAuthorizedFullpageModal
          open={open}
          setOpen={setOpen}
          onPress={onPress}
        />
      ) : (
        <Modal
          centered
          isOpen={isOpen}
          toggle={toggle}
        >
          <ModalBody>
            <div className="d-flex justify-content-center align-items-center flex-column">
              <img
                src={
                  type === "error"
                    ? Error
                    : type === "warning"
                      ? Warning
                      : type === "tryAgain"
                        ? TryAgainLaterIcon
                        : type === "forward"
                          ? ForwardTicketIcon
                          : type === "alert"
                            ? AlertIcon
                            : SuccessFill
                }
                className="mt-3"
              />
              <h3 className="mt-3">{title}</h3>
              <p className="text-center">{message}</p>
              <button
                className="btn btn-primary w-50 mt-2 mb-3"
                onClick={onPress}
                // style={{ borderRadius: '37px' }}
              >
                {buttonText}
              </button>
            </div>
          </ModalBody>
        </Modal>
      )}
    </>
  );
};

export default ErrorSuccessModal;
